// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "@rescript/std/lib/es6/curry.js";
import * as React from "react";
import * as Atom_Cta from "../atom/Atom_Cta.bs.js";
import * as Atom_Row from "../atom/Atom_Row.bs.js";
import * as Atom_Image from "../atom/Atom_Image.bs.js";
import * as Belt_Option from "@rescript/std/lib/es6/belt_Option.js";
import * as Caml_option from "@rescript/std/lib/es6/caml_option.js";
import * as Type_String from "../../type/Type_String.bs.js";
import * as UseTrackingPixel from "../../hook/UseTrackingPixel.bs.js";
import * as Particle_Screen_Constants from "../particle/Particle_Screen_Constants.bs.js";

function Molecule_Banner(Props) {
  var url = Props.url;
  var title = Props.title;
  var images = Props.images;
  var trackingPixel = Props.trackingPixel;
  var blockSpace = Props.blockSpace;
  var ref_ = Props.ref_;
  var handleBannerClick = UseTrackingPixel.make(Belt_Option.flatMap(trackingPixel, Type_String.TrackingPixel.toTypeUrl));
  var tmp = {
    children: React.createElement(Atom_Cta.Link.Block.make, {
          children: React.createElement(Atom_Image.make, {
                alt: Curry._1(Type_String.Teaser.Title.toString, title),
                src: images,
                style: /* Banner */1
              }),
          href: Curry._1(Type_String.Href.toString, url),
          onClick: handleBannerClick,
          style: /* Banner */4
        }),
    width: Particle_Screen_Constants.oneHundredPctWidth
  };
  if (blockSpace !== undefined) {
    tmp.blockSpace = Caml_option.valFromOption(blockSpace);
  }
  if (ref_ !== undefined) {
    tmp.ref_ = Caml_option.valFromOption(ref_);
  }
  return React.createElement(Atom_Row.make, tmp);
}

Molecule_Banner.displayName = "Banner";

var make = Molecule_Banner;

export {
  make ,
}
/*  Not a pure module */
